import { ModuleHtmlNode } from './createModuleHtmlNode';

/**
 * report-module：report-url 解析后展开的 HTML 内容模块。
 * 用 contentEditable + innerHTML 渲染 HTML 表格（对齐 V1 report-module/render.ts）。
 * 实现细节见 createModuleHtmlNode.tsx。
 */
export const ReportModuleNode = ModuleHtmlNode.createModuleNode(
  'report-module',
  'ReportModuleNode',
);
